export interface Search {
    search: string | null;
}
